import { RichTextPreview } from "web/components/Form/Controls"

export default function RichTextViewer({
  fieldKey,
  value,
  inert,
  readOnly,
  preventClickHandler,
}) {
  return (
    <RichTextPreview
      fieldKey={fieldKey}
      value={value}
      inert={inert}
      readOnly={readOnly}
      viewMode={true}
      preventClickHandler={preventClickHandler}
    />
  )
}

RichTextViewer.isViewerFor = (x) => x.kind === "RichText"
